import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { OperatorAdminService } from '../../services/operator-admin/operator-admin.service';
import { ToastService } from '../../services/toast/toast.service';
import { PermissionService } from '../../services/permission/permission.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';

@Component({
  selector: 'app-oa-block-day',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './oa-block-day.component.html',
  styleUrl: './oa-block-day.component.scss',
})
export class OaBlockDayComponent implements OnInit {
  date = new FormControl('');
  blockedDays: string[] = [];
  isLoading: boolean = false;
  canBlock: boolean = false;

  constructor(
    private operatorAdminService: OperatorAdminService,
    private toastService: ToastService,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.canBlock = this.permissionService.can('accommodation-block', 'can_block');
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.operatorAdminService.listBlockedDays().subscribe({
      next: (res: any) => {
        this.blockedDays = res?.data?.blockedDays || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.blockedDays = [];
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load blocked days.');
      },
    });
  }

  block(): void {
    const d = this.date.value;
    if (!d) {
      this.toastService.error('Pick a date to block.');
      return;
    }
    this.isLoading = true;
    this.operatorAdminService.blockDay(d).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Day blocked.');
        this.date.setValue('');
        this.load();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to block day.');
      },
    });
  }

  unblock(day: string): void {
    this.isLoading = true;
    this.operatorAdminService.unblockDay(day).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Day unblocked.');
        this.load();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to unblock day.');
      },
    });
  }
}
